import React, { useState } from "react";
import HeaderTop from "../components/Headertop";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import '../components/css/BlogStyle.css';
import blog1 from '../components/images/vigyan-vriksh-blog-img.jpg';
import popupsimg from '../components/images/vigyanvriksh_iit_gate.jpg';

function Up_gic_lecturer_recruitment2025(){
    const [showPopup, setShowPopup] = useState(true);
    return(
        <>
            <HeaderTop />
            <Navbar />

            {/* Popup Modal */}
            {showPopup && (
            <div className="popup-overlay">
                <div className="popup-box">
                {/* Close Button */}
                <button onClick={() => setShowPopup(false)} className="popup-close"><i class="bi bi-x-circle"></i></button>
                {/* Image with link */}
                <a href="https://vigyanvariksh.classx.co.in/" target="_blank" rel="noopener noreferrer">
                    <img src={popupsimg} alt="Vigyan Vriksh" className="popup-image" />
                </a>
                </div>
            </div>
            )}
            
            <section className="page-banner">
                <div className="container">
                    <div className="banner-content">
                        <h1 className="fw-bold">UP GIC Lecturer Recruitment 2025</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">UP GIC Lecturer Recruitment 2025</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <div class="container my-5">
                <div class="row g-4">
                    <div class="col-lg-9">
                        <figure>
                            <img src={blog1} alt=""  className="rounded blogdetailimg" />
                        </figure>
                        <h3>UP GIC Lecturer Recruitment 2025 Apply Online, Eligibility, Fee, Last Date</h3>
                        <p><b>Last Updated on: 20th August 2025</b></p>
                        <p><b>uppsc.up.nic.in Uttar Pradesh Public Service Commission (UPPSC)</b> UP GIC Lecturer Recruitment 2025, Eligibility, Fee, Last Date, Apply Online, UPPSC has released the new notification for the recruitment of UP LT Grade GIC Teacher New Vacancy 2025 for 1518 Posts, UP Government Inter College GIC Lecturer Online Registration Form 2025 has started from 12 August 2025 to 12 September 2025 through the official website of the Authority. The candidates who are interested for UP GIC Lecturer Bharti 2025, Kindly read the full notification related to UP GIC Lecturer Jobs 2025. Check Eligibility, Application Fee, Age Limit, Salary, Selection Process and all other information, All the details related to UP GIC Lecturer Online Registration Application Form 2025 Link is given below.</p>
                        <p><b>Uttar Pradesh Public Service Commission (UPPSC)</b></p>
                        <p><b>UP GIC Lecturer Recruitment 2025</b></p>
                        <p><Link to="">VIGYANVRIKSH.in</Link></p>
                        <div className="bloghighlightpoint">
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th style={{width : "50%"}}>IMPORTANT DATES</th>
                                    <th>APPLICATION FEE</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <ul className="list-unstyled">
                                            <li>Notification Date : <b>12 August 2025</b></li>
                                            <li>Application Start : <b>12 August 2025</b></li>
                                            <li>Last Date Apply Online : <b>12 September 2025</b></li>
                                            <li>Fee Payment Date : <b>12 September 2025</b></li>
                                            <li>Correction Last Date : <b>19 September 2025</b></li>
                                            <li>Admit Card <b>: Notify Later</b></li>
                                            <li>Exam Date : <b>Notify Later</b></li>
                                            <li>Result Date : <b>Notify Later</b></li>
                                            <li><b>Candidates are Advised to Verify the details on the Official Website of UPPSC.</b></li>
                                        </ul>
                                    </td>
                                    <td>
                                        <ul className="list-unstyled">
                                            <li>Gen/ OBC/ EWS : <b>₹125/-</b></li>
                                            <li>SC/ST : <b>₹65/-</b></li>
                                            <li>PH : <b>₹25/-</b></li>
                                            <li><b>Pay the Examination Fee Through Credit Card, Debit Card, Net Banking/ Pay Offline Through E-Challan.</b></li>
                                        </ul>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th style={{width : "50%"}}>AGE LIMIT AS ON 01.07.2025</th>
                                    <th>TOTAL POST</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <ul className="list-unstyled">
                                            <li>Minimum Age : <b>21 Years.</b></li>
                                            <li>Maximum Age : <b>40 Year</b></li>
                                            <li><b>For more complete information please read the UP GIC Lecturer Notification 2025.</b></li>
                                        </ul>
                                    </td>
                                    <td>
                                        <p><b>1518 Post</b></p>
                                        <p>For more complete information please read the UP GIC Lecturer Notification.</p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <h4>UP GIC Lecturer Category Wise Vacancy 2025</h4>
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th>Gender/ Category</th>
                                    <th>UR</th>
                                    <th>OBC</th>
                                    <th>EWS</th>
                                    <th>SC</th>
                                    <th>ST</th>
                                    <th>Posts</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Male</td>
                                    <td>292</td>
                                    <td>242</td>
                                    <td>73</td>
                                    <td>162</td>
                                    <td>08</td>
                                    <td>777</td>
                                </tr>
                                <tr>
                                    <td>Female</td>
                                    <td>330</td>
                                    <td>157</td>
                                    <td>64</td>
                                    <td>120</td>
                                    <td>23</td>
                                    <td>694</td>
                                </tr>
                                <tr>
                                    <td>Visually Impaired</td>
                                    <td>19</td>
                                    <td>14</td>
                                    <td>01</td>
                                    <td>11</td>
                                    <td>00</td>
                                    <td>45</td>
                                </tr>
                                <tr>
                                    <td>UP State Jail Training School</td>
                                    <td>02</td>
                                    <td>00</td>
                                    <td>00</td>
                                    <td>00</td>
                                    <td>00</td>
                                    <td>02</td>
                                </tr>
                                <tr>
                                    <td>Tota</td>
                                    <td>643</td>
                                    <td>413</td>
                                    <td>138</td>
                                    <td>293</td>
                                    <td>31</td>
                                    <td>1518</td>
                                </tr>
                                </tbody>
                            </table>
                            <h4>UP GIC Lecturer Eligibility 2025 Details</h4>
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th>Post Name</th>
                                    <th>UP GIC Lecturer Eligibility 2025</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td>Lecturer (Male/Female) – Sociology, Geography, Economics, Civics, Physics, Chemistry, Mathematics, English</td>
                                    <td>Master Degree in Relevant Subject OR Equivalent Eligibility From Any Recognized University/ Board/ Institutions in India With B.Ed. Degree Recognized by NCTE.</td>
                                    </tr>
                                    <tr>
                                    <td>Lecturer (Male/Female) – History</td>
                                    <td>Master Degree in Ancient/Medieval/Modern History OR Equivalent Eligibility From Any Recognized University/ Board/ Institutions in India With B.Ed. Degree Recognized by NCTE.</td>
                                    </tr>
                                    <tr>
                                    <td>Lecturer (Male/Female) – Biology</td>
                                    <td>Master Degree in Botany OR Zoology OR Equivalent Eligibility From Any Recognized University/ Board/ Institutions in India With B.Ed. Degree Recognized by NCTE.</td>
                                    </tr>
                                    <tr>
                                    <td>Lecturer (Male/Female) – Hindi</td>
                                    <td>Master Degree in Hindi and and Graduation in Arts with Sanskrit as a Subject OR Equivalent Eligibility From Any Recognized University/ Board/ Institutions in India With B.Ed. Degree Recognized by NCTE.</td>
                                    </tr>
                                    <tr>
                                    <td>Lecturer (Male/Female) – Urdu </td>
                                    <td>Master Degree in Urdu OR Equivalent Eligibility From Any Recognized University/ Board/ Institutions in India With B.Ed. Degree Recognized by NCTE.</td>
                                    </tr>
                                    <tr>
                                    <td>Lecturer (Male/Female) – Sanskrit</td>
                                    <td>Master Degree in Sanskrit OR Equivalent Eligibility From Any Recognized University/ Board/ Institutions in India With B.Ed. Degree Recognized by NCTE.</td>
                                    </tr>
                                    <tr>
                                    <td>Lecturer – Sparsh Inter College for Visually Handicapped (Subjects: Sociology, Economics, Civics, English, History, Hindi, Sanskrit)</td>
                                    <td>Master Degree in Related Subject OR Equivalent Eligibility From Any Recognized University/ Board/ Institutions in India With Special B.Ed. or M.Ed. in Visual/Hearing Impairment recognized by RCI, and Knowledge of Braille/Sign Language, RCI Registration as a Special Educator.</td>
                                    </tr>
                                    <tr>
                                    <td>Lecturer in Psychology (UP Jail Training School)</td>
                                    <td>Master Degree in Psychology with paper in Criminal Psychology OR Master Degree in Psychology with Diploma in Criminology OR Master Degree in Psychology with paper in M.A. level Social Pathology/Social Disorganization/Criminology Dissertation OR Equivalent Eligibility From Any Recognized University/ Board/ Institutions in India.</td>
                                    </tr>
                                    <tr>
                                    <td>Lecturer in Criminology and Penology (UP Jail Training School)</td>
                                    <td>Master Degree in Sociology, Social Work, Anthropology, or Psychology, with at least one full paper in:
                                    (A) Sociology/Social Pathology/Social Psychology/Social Anthropology<br/>
                                    (B) Criminology and Penology or Criminal Psychology<br/>
                                    For more complete information kindly read the UP GIC Lecturer Recruitment Exam Notification 2025</td>
                                </tr>
                                </tbody>
                            </table>
                            <h4>UP GIC Lecturer Salary 2025</h4>
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th style={{width : "50%"}}>Allowance</th>
                                    <th>Amount (₹)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Salary</td>
                                    <td>₹9,300/- to ₹34,800/- Per Month.</td>
                                </tr>
                                <tr>
                                    <td>Grade Pay</td>
                                    <td>₹4,800/-</td>
                                </tr>
                                <tr>
                                    <td>Other Allowances</td>
                                    <td>As Per Government Rules.</td>
                                </tr>
                                </tbody>
                            </table>

                            <h4>UP GIC Lecturer 2025 Selection Process</h4>
                            <p>The Selection Process for UP GIC Lecturer Recruitment 2025 will be completed on the following phases –</p>
                            <ul className="list-unstyled">
                                <li>Written Exam.</li>
                                <li>Interview.</li>
                                <li>Document Verification.</li>
                                <li>Final Merit List.</li>
                                <li>Merit List.</li>
                            </ul>
                            <p><b>How to UP GIC Lecturer Recruitment 2025 Apply Online?</b></p>
                            <p>Uttar Pradesh Public Service Commission (UPPSC), will be started the uppsc.up.nic.in UP GIC Lecturer Recruitment 2025 from  12 August 2025 for UP GIC Lecturer Bharti 2025. Follow these steps for UP GIC Lecturer Online Registartion Application Form 2025 Link.</p>
                            <ul className="list-unstyled">
                                <li>First of all need to Check the UP GIC Lecturer Notification 2025 PDF.</li>
                                <li>Click on the Apply Online Link given below or visit the official website of the Authority uppsc.up.nic.in UP GIC Lecturer Recruitment 2025 through OTR (One Time Registration).</li>
                                <li>Fill out the UP GIC Lecturer Online Application Form 2025.</li>
                                <li>Upload the Required Documents.</li>
                                <li>Pay Application Fees.</li>
                                <li>Finally Print the Application Form.</li>
                            </ul>

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan={2}>IF You Satisfied By vigyanvriksh.in Please Join Our WhatsApp & Telegram Channel (Thanks).</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Join Our WhatsApp Channel</td>
                                    <td><Link to="https://www.whatsapp.com/channel/0029VaCqVSE7oQhW1AVSxi1O" target="_blank">Follow Now</Link></td>
                                </tr>
                                <tr>
                                    <td>Join Our Telegram Channel</td>
                                    <td><Link to="https://t.me/examsarkarijob" target="_blank">Follow Now</Link></td>
                                </tr>
                                </tbody>
                            </table>

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan={2}>IMPORTANT LINKS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Apply Online</td>
                                    <td><Link to="https://uppsc.up.nic.in/CandidatePages/Notifications.aspx" target="_blank">Click Here</Link></td>
                                </tr>
                                <tr>
                                    <td>Download Notification</td>
                                    <td><Link to="https://uppsc.up.nic.in/OuterPages/View_Enclosure.aspx?ID=744&flag=H&FID=893" target="_blank">Hindi</Link>||<Link to="https://uppsc.up.nic.in/OuterPages/View_Enclosure.aspx?ID=744&flag=E&FID=894" target="_blank">Englis</Link></td>
                                </tr>
                                <tr>
                                    <td>Official Website</td>
                                    <td><Link to="https://uppsc.up.nic.in/" target="_blank">Click Here</Link></td>
                                </tr>
                                <tr>
                                    <td>Homepage</td>
                                    <td><Link to="https://vigyanvriksh.in/" target="_blank">Click Here</Link></td>
                                </tr>
                                </tbody>
                            </table>

                            <h4>Frequently Asked Questions (FAQs)</h4>
                            <p><b>What is the UP GIC Lecturer Online Form 2025 Start Date?</b></p>
                            <p>12 August 2025.</p>
                            <p><b>What is the UP GIC Lecturer Official Website 2025?</b></p>
                            <p>uppsc.up.nic.in.</p>
                            <p><b>What is the UP GIC Lecturer Online Form 2025 Last Date?</b></p>
                            <p>12 September 2025.</p>
                            <p><b>What is the UP GIC Lecturer Exam Date 2025?</b></p>
                            <p>Notify Later.</p>

                        </div>
                    </div>

                    <div class="col-lg-3">
                        <div class="sidebar-box">
                            <h5>Search</h5>
                            <div class="input-group mt-3">
                                <input type="text" class="form-control" placeholder="Enter Keyword" />
                                <button class="btn btn-light"><i class="bi bi-search"></i></button>
                            </div>
                        </div>
                        <div class="sidebar-box">
                            <h5>Recent Posts</h5>
                            <div class="recent-post mt-3">
                                <ul className="list-unstyled">
                                    <li><Link to="/Upgiclecturerrecruitment2025">UP GIC Lecturer Recruitment 2025 Apply Online, Eligibility, Fee, Last Date</Link></li>
                                    <li><Link to="/RPSCSchoollecturer2025">RPSC School Lecturer Recruitment 2025 [3225 Post] Apply Online</Link></li>
                                    <li><Link to="/GATEExamination2026">GATE Examination 2026</Link></li>
                                    <li><Link to="/BiharBPSCAESRecruitment2025">Read More</Link></li>
                                </ul>
                                <div>
                                    <p class="mb-0"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
export default Up_gic_lecturer_recruitment2025;